type localesKeys__SkillsChart = {
  headLinkLabel__defaultText: string;
  headLabel__defaultText: string;
  skillsModal__close: string;
  skillsModal__noDescription: string;
  skillsModal__clickHint: string;
}

const ruLocale__SkillsChart: localesKeys__SkillsChart = {
    headLinkLabel__defaultText: 'Подробнее',
    headLabel__defaultText: 'Навыки',
    skillsModal__close: 'Закрыть',
    skillsModal__noDescription: 'Нет описания.',
    skillsModal__clickHint: 'Нажми для деталей'
};

const enLocale__SkillsChart: localesKeys__SkillsChart = {
  headLinkLabel__defaultText: 'More details',
  headLabel__defaultText: 'Skills',
  skillsModal__close: 'Close',
  skillsModal__noDescription: 'No description.',
  skillsModal__clickHint: 'Click for details'
};

export { ruLocale__SkillsChart, enLocale__SkillsChart };
export type { localesKeys__SkillsChart };
